exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.swiper-demo-img img[data-v-1c71b1d2] {\n  max-width: 100%;\n  height: 4rem !important;\n}\n.home_conent[data-v-1c71b1d2] {\n  padding: 0 0.43rem;\n}\n.home-living[data-v-1c71b1d2] {\n  padding: 0 0.43rem;\n  border-bottom: 0.19rem solid #f4f4f4;\n}\n", ""]);

// exports
